"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Stats = void 0;
const React = __importStar(require("react"));
const ProjectDashboardDataProvider_1 = require("src/hello_assets/src/components/ui/loggedin/content/project/withData/dashboard/ProjectDashboardDataProvider");
const antd_1 = require("antd");
const Stats = () => {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q;
    const currentProjectDataContext = (0, ProjectDashboardDataProvider_1.useProjectDashboardDataContext)();
    const state = currentProjectDataContext.stateQueryCalls;
    return React.createElement(antd_1.Row, { gutter: [32, 16] },
        React.createElement(antd_1.Col, { flex: 1 },
            React.createElement(antd_1.Statistic, { title: "Active Users Today", value: (_c = (_b = (_a = state.data) === null || _a === void 0 ? void 0 : _a.stats) === null || _b === void 0 ? void 0 : _b.state) === null || _c === void 0 ? void 0 : _c.dauToday })),
        React.createElement(antd_1.Col, { flex: 1 },
            React.createElement(antd_1.Statistic, { title: "Active Users Last 7 Days", value: (_f = (_e = (_d = state.data) === null || _d === void 0 ? void 0 : _d.stats) === null || _e === void 0 ? void 0 : _e.state) === null || _f === void 0 ? void 0 : _f.dauThisWeek })),
        React.createElement(antd_1.Col, { flex: 1 },
            React.createElement(antd_1.Statistic, { title: "New Users Today", value: (_j = (_h = (_g = state.data) === null || _g === void 0 ? void 0 : _g.stats) === null || _h === void 0 ? void 0 : _h.state) === null || _j === void 0 ? void 0 : _j.newUsersToday })),
        React.createElement(antd_1.Col, { flex: 1 },
            React.createElement(antd_1.Statistic, { title: "New Users Last 7 Days", value: (_m = (_l = (_k = state.data) === null || _k === void 0 ? void 0 : _k.stats) === null || _l === void 0 ? void 0 : _l.state) === null || _m === void 0 ? void 0 : _m.newUsersThisWeek })),
        React.createElement(antd_1.Col, { flex: 1 },
            React.createElement(antd_1.Statistic, { title: "Total Users", value: (_q = (_p = (_o = state.data) === null || _o === void 0 ? void 0 : _o.stats) === null || _p === void 0 ? void 0 : _p.state) === null || _q === void 0 ? void 0 : _q.totalUsers })));
};
exports.Stats = Stats;
